import labels from "../../utils/labels"
import LabeledSection from "../UI/LabeledSection"
import EmployeeTransportType from "./EmployeeTransportType"
import EmployeeWorktime from "./EmployeeWorkTime"

const EmployeeSettingsTab = ({
  onEmployeeUnsavedEdit
}: {
  onEmployeeUnsavedEdit: (hasChanges: boolean) => void
}) => {

  return (
    <>
      {/* daily settings */}
      <LabeledSection title={labels.dailySettings}>
        <EmployeeWorktime onUnsavedEdit={onEmployeeUnsavedEdit} />
        <EmployeeTransportType />
      </LabeledSection>

      {/* permanent settings */}
      <LabeledSection title={labels.permanentSettings}>
        <p>settings...</p>
      </LabeledSection>
    </>
  )
}

export default EmployeeSettingsTab